var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('search-filter',{ref:"filters",staticClass:"margin-bottom-2",attrs:{"taxonomy":_vm.taxonomy,"isTaxonomyLoading":_vm.isTaxonomyLoading,"includeCount":false,"parentSelectedFilters":_vm.categoryFilters},on:{"filtersChanged":_vm.filtersChanged,"sectionExpanded":_vm.nodeExpanded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }